<template>
    <section class="social-wall-detail" id="social-wall-detail" @click.self="hideModal()">
        <div class="close-button"><span class="icon-cross"></span>Fermer</div>
        <div class="nav-arrows">
            <div class="btn-nav left" @click="prevSlide()" v-if="!reachStart">
                <div class="bg-arrow"></div>
                <span class="icon-arrow-right-swiper"></span>
            </div>
            <div class="btn-nav deactivated" v-else>
                <div class="bg-arrow"></div>
            </div>
        </div>
        <transition :name="transitionName" mode="out-in">
            <div class="wrap-content"
                 v-for="(item, index) in items"
                 v-if="isActive(index)"
                 :key="index"
                 v-touch:swipe.left="nextSlide"
                 v-touch:swipe.right="prevSlide"
            >
                <div class="photo" :style="'background-image: url('+item.photoUrl+')'"></div>
                <div class="description">
                    <div class="wrap-titre">
                        <span class="icon-pin-location-icomoon"></span>
                        <span class="titre" v-html="item.destinationName"></span>
                    </div>
                    <div class="bar"></div>
                    <p class="label">Par :</p>
                    <p v-html="formatTitle(item.prenom, item.ville)"></p>
                    <div class="bar"></div>
                    <p class="label">Date de mise en ligne :</p>
                    <p v-html="item.date"></p>
                    <div class="bar"></div>
                    <p class="commentaire" v-html="item.commentaire"></p>
                    <div class="bar"></div>
                    <div class="wrap-social">
                        <p class="label">Partager</p>
                        <share-social-photo></share-social-photo>
                    </div>

                </div>
            </div>
        </transition>
        <div class="nav-arrows">
            <div class="btn-nav" @click="nextSlide()" v-if="!reachEnd">
                <div class="bg-arrow"></div>
                <span class="icon-arrow-right-swiper"></span>
            </div>
            <div class="btn-nav deactivated" v-else>
                <div class="bg-arrow"></div>
            </div>
        </div>
    </section>
</template>

<script>
    import Modal from '../../libs/Modal'

    export default {
        props: {
            items: {
                type: Array,
                required: true,
            },
            clickedIndex: {
                type: Number,
                required: true,
            },
        },
        data() {
            return {
                activeIndex: 0,
                transitionName: 'slide-right'
            };
        },
        watch: {
            clickedIndex(newValue, lastValue) {
                this.transitionName = 'none'
                this.activeIndex = newValue
            },
        },
        computed: {
            reachStart() {
                return this.activeIndex === 0
            },
            reachEnd() {
                return this.activeIndex === this.items.length - 1
            }
        },
        methods: {
            isActive(index) {
                return index === this.activeIndex
            },
            hideModal() {
                Modal.hideModal('#social-wall-detail')
            },
            nextSlide() {
                this.transitionName = 'slide-right'
                if (!this.reachEnd) {
                    this.activeIndex++
                }
            },
            prevSlide() {
                this.transitionName = 'slide-left'
                if (!this.reachStart) {
                    this.activeIndex--
                }
            },
            formatTitle(prenom, ville) {
                return prenom + ', ' + ville
            }
        },
        created() {

        },
    }
</script>


// WEBPACK FOOTER //
// assets/js/components/social-wall/SocialWallDetail.vue